"use client";

import { ModalContent as HeroModalContent } from "@heroui/react";
import { cn } from "../../lib/utils";

export const ModalContent = ({
  className,
  ...props
}: { className?: string } & React.ComponentProps<typeof HeroModalContent>) => {
  return <HeroModalContent className={cn(className)} {...props} />;
};
